import React from "react";
import { getObjectByKey } from "../../../utils/utils";
import { useSelector } from "react-redux";
import Widget from "../../features/widget/Widget";
import crbWidgetImg from "../../../../assests/crb/crbWidget.png";
import classes from "./CrbWidget.module.css";

const CrbWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const { platforms } = useSelector(state => state.uiData);
    const crb = getObjectByKey("crb", platforms)

    return (
        <Widget
            color="linear-gradient(180deg, #184752 0%, #35A0B8 100%)"
            title={texts.crb}
            titleColor={"white"}
            mainLink={crb?.link}
            className={classes.CrbWidget}
        >
            <div className={classes.CrbContent}>
                <img src={crbWidgetImg} alt="" className={classes.CrbImg} />
            </div>
        </Widget>
    );
};

export default CrbWidget;
